<mat-form-field [subscriptSizing]="data.subscriptSizing ?? 'fixed'" color="accent">
  @if (data.label) {
    <mat-label>{{ data.label }}</mat-label>
  }

  <textarea
    #matInput="matInput"
    [control]="control"
    [data]="data"
    [formControl]="control"
    [placeholder]="data.placeholder || ''"
    [type]="data.type"
    [rows]="data.rows"
    [cols]="data.cols"
    matInput
    uiFormInputAttributes
    uiFormInputValidators
  ></textarea>

  @if (control.enabled && !data.attributes?.readOnly && (control.value || matInput.errorState)) {
    <button
      (click)="$event.preventDefault();$event.stopPropagation();control.setValue('')"
      [color]="matInput.errorState ? 'warn' : undefined"
      mat-icon-button
      matSuffix
      type="button"
      aria-label="Schließen"
    >
      <ui-icon [faName]="control.valid ? 'circle-xmark' : 'circle-exclamation'" faStyle="light"></ui-icon>
    </button>
  }

  <mat-error [control]="control" [data]="data" uiFormError></mat-error>

  @if (data.hint) {
    <mat-hint [innerHtml]="data.hint"></mat-hint>
  }

  @if (data.attributes?.maxLength) {
    <mat-hint align="end">
      {{ (control.value?.length ?? 0) }} / {{ data.attributes.maxLength }}
    </mat-hint>
  }
</mat-form-field>

@if (data.description) {
  <ui-form-input-description [description]="data.description"></ui-form-input-description>
}
